<template>
  <div
    class="navbar_container flex justify-center"
    :class="scroll >= scrollFLag ? 'navbar_container_active' : ''"
    :style="fixed ? 'position: fixed; top: 0;' : '' + uiStyle"
  >
    <div class="navbar-box flex">
      <img class="navbar-logo" src="@/assets/logo.png" alt="" />
      <div class="navbar-text">电喵科技</div>
    </div>
    <div class="nav-box flex">
      <div class="nav-item" @click="handleNav('/')" :class="currentVal == '/' ? 'nav-item-active' : ''">首页</div>

      <div class="nav-item" @click="handleNav('/AIoT')" :class="currentVal == '/AIoT' ? 'nav-item-active' : ''">
        AIoT平台
      </div>
      <div class="nav-item" @click="handleNav('/resolve')" :class="currentVal == '/resolve' ? 'nav-item-active' : ''">
        解决方案
      </div>
      <div class="nav-item" @click="handleNav('/shop')" :class="currentVal == '/shop' ? 'nav-item-active' : ''">
        产品中心
      </div>
      <div class="nav-item" @click="handleNav('/service')" :class="currentVal == '/about' ? 'nav-item-active' : ''">
        运维服务
      </div>
      <div
        class="nav-item"
        @click="handleNav('/application')"
        :class="currentVal == '/application' ? 'nav-item-active' : ''"
      >
        案例展示
      </div>
      <div class="nav-item" @click="handleNav('/about')" :class="currentVal == '/about' ? 'nav-item-active' : ''">
        最新动态
      </div>
      <div class="nav-item" @click="handleNav('/connect')" :class="currentVal == '/connect' ? 'nav-item-active' : ''">
        联系我们
      </div>
    </div>
    <div class="navbar-shop pointer" v-if="shopFlag" @click="handleOpenCar">清单</div>
  </div>
</template>

<script>
export default {
  name: "navbar",
  props: {
    scrollFLag: {
      type: Number,
      default: 60,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    uiStyle: String,
    shopFlag: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      currentVal: "/",
      scroll: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 跳转
    handleNav(url) {
      if (this.$router.currentRoute.path !== url) {
        this.$router.push(url);
        this.currentVal = url;
      }
    },
    handleOpen(url) {
      const { href } = this.$router.resolve({
        path: url, // 你想跳转到的路径
        query: { index: 1 }, // 可选，带 query 参数
      });
      const fullUrl = window.location.origin + href;
      window.open(fullUrl, "_blank");
    },
    // 获取屏幕位置
    handleScroll() {
      this.scroll = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    },
    handleOpenCar() {
      this.$emit("handle-open-car");
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.navbar_container_active {
  color: #2c3e50 !important;
  background: #fff !important;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}
.navbar_container {
  width: 100vw;
  height: 65px;
  z-index: 999;
  transition: background 0.5s ease, color 0.5s ease;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 7%, rgba(0, 0, 0, 0) 100%);
  color: #fff;
  position: relative;

  .navbar-box {
    position: absolute;
    left: 30px;
    top: 17.5px;

    .navbar-logo {
      width: 30px;
      height: 30px;
    }

    .navbar-text {
      height: 30px;
      line-height: 30px;
      font-size: 24px;
      margin-left: 10px;
      font-weight: bold;
    }
  }

  .nav-box {
    height: 65px;
    justify-content: center;
    align-items: center;

    .nav-item {
      padding: 0 20px;
      cursor: pointer;
      font-weight: 600;
    }

    .nav-item-active {
      font-weight: bold;
    }
  }

  .navbar-shop {
    position: absolute;
    right: 30px;
    top: 17.5px;
    background: #fff;
    color: #333;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
